/**
 * Whether an `href` row renders a link element. On web it does, and the browser
 * follows it.
 */
export const hrefRowIsAnchor = true;
